import React, { createContext, useState } from 'react';

export const UserContext = createContext();

export const UserProvider = ({ children }) => {
    const [currentDiagnosis, setCurrentDiagnosis] = useState(null);
    const [diagnosisHistory, setDiagnosisHistory] = useState([]);
    const [progress, setProgress] = useState({
        completedSections: 0,
        totalSections: 0,
        currentSection: null
    });

    const startDiagnosis = (diagnosisData) => {
        setCurrentDiagnosis(diagnosisData);
    };

    const updateProgress = (progressData) => {
        setProgress(prev => ({ ...prev, ...progressData }));
    };

    const completeDiagnosis = (result) => {
        setDiagnosisHistory(prev => [...prev, result]);
        setCurrentDiagnosis(null);
        setProgress({
            completedSections: 0,
            totalSections: 0,
            currentSection: null
        });
    };

    const value = {
        currentDiagnosis,
        diagnosisHistory,
        progress,
        startDiagnosis,
        updateProgress,
        completeDiagnosis
    };

    return (
        <UserContext.Provider value={value}>
            {children}
        </UserContext.Provider>
    );
};

export default UserContext;
